import { useTaskChangeLog } from '@sib/api';
import {
  EntityActivityLogItem,
  EntityActivityLogList,
} from '@sidecar/common/components/DetailsModal';
import { useTaskActivityLogLabels } from './TaskActivityLog.utils';

interface TaskActivityLogTabContentProps {
  taskId: string;
}

export const TaskActivityLogTabContent = ({
  taskId,
}: TaskActivityLogTabContentProps) => {
  const { t, actionKeys, getItemDescriptions } = useTaskActivityLogLabels();
  const { data: changelog, isLoading } = useTaskChangeLog(taskId);

  const items = changelog?.items ?? [];

  return (
    <EntityActivityLogList
      isLoading={isLoading}
      isEmpty={items.length === 0}
      emptyLabel={t('components.taskDetails.activityLog.empty')}
    >
      {items.map(item => (
        <EntityActivityLogItem
          key={item.afterChangesVersionId}
          itemKey={`task-activity-${item.afterChangesVersionId}`}
          modifiedBy={item.modifiedBy}
          modifiedAt={item.modifiedAt}
          descriptions={getItemDescriptions(item)}
          actionKeys={actionKeys}
          ns="common"
        />
      ))}
    </EntityActivityLogList>
  );
};
